import React, { useRef } from "react";
import { Grid } from "@mui/material";
import { PageLayout } from "@icoach/components";
import MemberDetailSummary from "@icoach/memberDetail/MemberDetailSummary";
import MemberDetailSideBar from "@icoach/memberDetail/MemberDetailSideBar";
import { MemberDetailProvider } from "@icoach/memberDetail/MemberDetailContext";
import MemberDetailDialogBox from "@icoach/memberDetail/dialog/MemberDetailDialogBox";
import MemberDetailWorkoutContent from "@icoach/memberDetail/MemberDetailWorkoutContent";
import MemberDetailBasicInfoContent from "@icoach/memberDetail/MemberDetailBasicInfoContent";
import MemberDetailMembershipContent from "@icoach/memberDetail/MemberDetailMembershipContent";
import MemberDetailInbodyContent from "@icoach/memberDetail/MemberDetailInbodyContent";
import MemberDetailContactRecordContent from "@icoach/memberDetail/MemberDetailContactRecordContent";
import MemberDetailCycleOrderContent from "@icoach/memberDetail/MemberDetailCycleOrderContent";
import MemberDetailRentCabinetContent from "@icoach/memberDetail/MemberDetailRentCabinetContent";
import MemberDetailOtherContent from "@icoach/memberDetail/MemberDetailOtherContent";
import useGetMemberProfileState from "@util/hook/useGetMemberProfileState";
import { isEqual } from "@util/utils";
import { MEMBERS_MEMBER_DETAIL_TABS } from "@icoach/constants";
import MemberDetailSmartFitnessBandContent from "@icoach/memberDetail/MemberDetailSmartFitnessBandContent";

const MemberDetailPage = props => {
	const { memberID, tab: activeTab } = props.match.params;
	const { memberProfile, ...memberProfileOther } = useGetMemberProfileState({ memberID });
	const dialogRef = useRef(null);
	const refreshRef = useRef();

	return (
		<>
			{
				!isEqual(memberProfile.memberID, 0) &&
				<MemberDetailProvider
					value={{
						memberProfile,
						...memberProfileOther,
						dialogRef,
						refresh: refreshRef,
						setRefresh: (fn) => (refreshRef.current = fn)
					}}
				>
					<PageLayout className="member-information-page">
						<Grid container spacing={2}>
							<Grid item xs={9}>
								<MemberDetailSummary sourceData={memberProfile} className="mb-2" memberID={memberID}
													 activeTab={activeTab} />
								{isEqual(activeTab, MEMBERS_MEMBER_DETAIL_TABS.WORKOUT) && (
									<MemberDetailWorkoutContent memberID={memberID} sourceData={memberProfile} />
								)}
								{isEqual(activeTab, MEMBERS_MEMBER_DETAIL_TABS.BASIC) && (
									<MemberDetailBasicInfoContent memberID={memberID} sourceData={memberProfile} />
								)}
								{isEqual(activeTab, MEMBERS_MEMBER_DETAIL_TABS.MEMBERSHIP) && (
									<MemberDetailMembershipContent memberID={memberID} sourceData={memberProfile} />
								)}
								{isEqual(activeTab, MEMBERS_MEMBER_DETAIL_TABS.INBODY) &&
									<MemberDetailInbodyContent memberID={memberID} sourceData={memberProfile} />}
								{isEqual(activeTab, MEMBERS_MEMBER_DETAIL_TABS.CONTACT_RECORD) && (
									<MemberDetailContactRecordContent memberID={memberID}
																	  sourceData={memberProfile} />
								)}
								{isEqual(activeTab, MEMBERS_MEMBER_DETAIL_TABS.HC) &&
									<MemberDetailCycleOrderContent memberID={memberID}
																   sourceData={memberProfile} />}
								{isEqual(activeTab, MEMBERS_MEMBER_DETAIL_TABS.RENT_CABINET) && (
									<MemberDetailRentCabinetContent memberID={memberID}
																	sourceData={memberProfile} />
								)}
								{isEqual(activeTab, MEMBERS_MEMBER_DETAIL_TABS.OTHER) &&
									<MemberDetailOtherContent memberID={memberID} sourceData={memberProfile} />}
								{isEqual(activeTab, MEMBERS_MEMBER_DETAIL_TABS.SMARTFITNESSBAND) &&
									<MemberDetailSmartFitnessBandContent memberID={memberID}
																		 sourdeData={memberProfile} />}
							</Grid>
							<Grid item xs={3}>
								<MemberDetailSideBar memberID={memberID} sourceData={memberProfile}
													 dialogRef={dialogRef} />
							</Grid>
						</Grid>
					</PageLayout>
					<MemberDetailDialogBox ref={dialogRef} />
				</MemberDetailProvider>
			}

		</>
	);
};

export default MemberDetailPage;
